module.exports = __webpack_public_path__ + "img/logo.93895f95.svg";